import type { CloudGraphCustomerOrgEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI: CloudGraphCustomerOrgEntityAti[] = [
	'ati:cloud:graph:customer-org',
];
